import { themes } from '../app/enums';
import { Location } from './location.interface';

export interface User {
  id: string
  userType: string
  firstName: string
  lastName: string
  email: string
  userName: string
  enabled: boolean  
  settings?: string
}

export interface UserType {
  id: string
  userType: string
  firstName: string
  lastName: string
  email: string
  userName: string
  password?: string
  authenticated: boolean
  enabled: boolean
  settings: string
  locations: Location[]
}

export interface UserContextType {
  accessToken: string
  self: UserType
  currentPage?: string
  usersList: UserType[]
  userTheme: string
}

export const defaultUserType: UserType = { 
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  userName: '',
  password: '',
  authenticated: false,
  locations: [],
  enabled: false,
  settings: '',
  userType: '-1'
}

export const defaultUserContext: UserContextType = {
  self: defaultUserType,
  currentPage: '',
  usersList: [],
  userTheme: themes.DEFAULT,
  accessToken: '',
};

export interface UserResponse {
  id: string,
  firstName: string,
  lastName: string,
  email: string,
  userName: string,
  enabled: boolean,
}
